import { Injectable } from '@angular/core';
import { Delivery } from './app/delivery-service';
import { BaseHttpService, PageResponse } from '../auth/base-capacitor-http';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';

export class RouteProgress {
  stops: number;
  packages: number;
  remaining: number;
  completed: number;
  est_finish: number;
}

export class Route {
  id: number;
  name: string;
  location: string;
  driver: string;
  status: string;
  created: number;
  deliveries: Delivery[] = [];
}

export class RouteSearchParams {
  page: number = 0;
  size: number = 10;
  status: string;
  sort: string;
  search: string;
}



@Injectable({
  providedIn: 'root',
})
export class RouteService extends BaseHttpService {


  private readonly baseURL: string;
  private endPointURL: string;
  constructor(protected client: HttpClient, protected snackbar: MatSnackBar) {
    super(client, snackbar);
    this.baseURL = environment.server.mainURL + 'delivery-route';
  }

  calcRouteProgress(route: Route) {
    return new RouteProgress();
  }

  async create(data: Route) {
    this.endPointURL = this.baseURL;
    return await this.post<Route>(this.endPointURL, data);
  }

  async update(data: Route) {
    this.endPointURL = this.baseURL;
    return await this.put<Route>(this.endPointURL, data);
  }

  async deleteById(id: string) {
    this.endPointURL = this.baseURL + '/' + id;
    return await this.delete<boolean>(this.endPointURL);
  }

  async findAll(searchParams: RouteSearchParams) {
    this.endPointURL = this.baseURL;
    return await this.get<PageResponse<Route>>(this.endPointURL, searchParams);
  }

  async findById(id: string) {
    this.endPointURL = this.baseURL + '/' + id;
    return await this.get<Route>(this.endPointURL);
  }

  async findByRef(ref: string) {
    this.endPointURL = this.baseURL + '/ref/' + ref;
    return await this.get<Route>(this.endPointURL);
  }


}
